// src/components/ContentPickerPanel.jsx
import React from "react";

const DEMO_STREAM_URL = "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8";

const PROVIDER_LEVELS = {
  free: 0,
  sports: 1,
  all_access: 2,
};

// Secties + items (met jouw thumbs)
const SECTIONS = [
  {
    id: "free",
    label: "Free",
    tagline: "Gratis demo-kanalen om Bond te proberen.",
    items: [
      {
        id: "free-az-psv",
        providerId: "free",
        matchTitle: "AZ – PSV",
        thumb: "/images/AZ-PSV_thumb.png",
      },
    ],
  },
  {
    id: "sports",
    label: "Sports",
    tagline: "Extra sportkanalen voor sport-abonnees.",
    items: [
      {
        id: "sports-manu-liv",
        providerId: "sports",
        matchTitle: "Manchester United – Liverpool",
        thumb: "/images/ManU-Liv_thumb.png",
      },
    ],
  },
  {
    id: "all-access",
    label: "All Access",
    tagline: "Toegang tot alle demo-kanalen (premium).",
    items: [
      {
        id: "all-access-liv-psv",
        providerId: "all_access",
        matchTitle: "Liverpool – PSV",
        thumb: "/images/Liv-PSV_thumb.png",
      },
      {
        id: "all-access-bayern-arsenal",
        providerId: "all_access",
        matchTitle: "FC Bayern – Arsenal",
        thumb: "/images/Bayern-Arsenal_thumb.png",
      },
    ],
  },
];

export default function ContentPickerPanel({
  onCancel,
  onSelect,
  maxPackageLevel = 0,
}) {
  function handleSelect(item) {
    if (!onSelect) return;

    onSelect({
      providerId: item.providerId,
      assetId: item.id,
      title: item.matchTitle,
      assetUrl: DEMO_STREAM_URL,
    });
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        background: "rgba(15,23,42,0.85)",
        backdropFilter: "blur(10px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onCancel}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 1080,
          maxHeight: "80vh",
          background:
            "radial-gradient(120% 150% at 0% 0%, #020617 0%, #020617 45%, #020617 100%)",
          borderRadius: 26,
          border: "1px solid rgba(148,163,184,0.3)",
          boxShadow: "0 32px 120px rgba(0,0,0,0.85)",
          display: "flex",
          flexDirection: "column",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            padding: "18px 26px 10px",
            borderBottom: "1px solid rgba(30,64,175,0.35)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 16,
          }}
        >
          <div>
            <div
              style={{
                fontSize: 13,
                fontWeight: 700,
                letterSpacing: "0.18em",
                textTransform: "uppercase",
                color: "#9ca3af",
              }}
            >
              BOND
            </div>
            <div
              style={{
                marginTop: 4,
                fontSize: 19,
                fontWeight: 600,
              }}
            >
              Kies je wedstrijd / kanaal
            </div>
            <div
              style={{
                marginTop: 2,
                fontSize: 13,
                color: "#9ca3af",
              }}
            >
              Selecteer eerst een demo-wedstrijd. Daarna starten we je
              Bondsessie (solo of met vrienden).
            </div>
          </div>

          <button
            onClick={onCancel}
            style={{
              border: "none",
              borderRadius: 999,
              width: 32,
              height: 32,
              display: "grid",
              placeItems: "center",
              background: "rgba(15,23,42,0.95)",
              color: "#9ca3af",
              cursor: "pointer",
              fontSize: 18,
            }}
          >
            ×
          </button>
        </div>

        {/* Scrollbare content */}
        <div
          className="bond-picker-scroll"
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "16px 26px 20px",
          }}
        >
          {SECTIONS.map((section) => (
            <div key={section.id} style={{ marginBottom: 26 }}>
              {/* Sectie-header */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  marginBottom: 10,
                }}
              >
                <span
                  style={{
                    padding: "3px 11px",
                    borderRadius: 999,
                    fontSize: 12,
                    fontWeight: 600,
                    background: "rgba(15,23,42,0.95)",
                    border: "1px solid rgba(148,163,184,0.35)",
                  }}
                >
                  {section.label}
                </span>
                <span
                  style={{
                    fontSize: 12,
                    color: "#9ca3af",
                  }}
                >
                  {section.tagline}
                </span>
              </div>

              {/* Cards links uitgelijnd */}
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 18,
                  justifyContent: "flex-start",
                }}
              >
                {section.items.map((item) => {
                  const providerId = item.providerId || "free";
                  const requiredLevel =
                    PROVIDER_LEVELS[providerId] ?? 0;
                  const locked = requiredLevel > maxPackageLevel;

                  return (
                    <MatchCard
                      key={item.id}
                      item={item}
                      locked={locked}
                      onSelect={handleSelect}
                    />
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/** Eén wedstrijd-card */
function MatchCard({ item, locked, onSelect }) {
  const handleClick = () => {
    if (locked) return; // 🔒 geen rechten → geen actie
    onSelect?.(item);
  };

  const thumbStyle = item.thumb
    ? {
        backgroundImage: `url(${item.thumb})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : {
        background:
          "linear-gradient(135deg, #020617 0%, #020617 30%, #111827 70%, #020617 100%)",
      };

  return (
    <button
      onClick={handleClick}
      style={{
        border: "none",
        padding: 0,
        cursor: locked ? "default" : "pointer",
        textAlign: "left",
        background: "transparent",
        opacity: locked ? 0.6 : 1,
      }}
    >
      <div
        style={{
          width: 380,
          maxWidth: "100%",
          borderRadius: 18,
          overflow: "hidden",
          border: "1px solid rgba(30,64,175,0.6)",
          background:
            "radial-gradient(circle at 0% 0%, #1d2544 0%, #020617 55%, #020617 100%)",
          boxShadow:
            "0 18px 50px rgba(15,23,42,0.85), 0 0 0 1px rgba(15,23,42,0.8) inset",
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        {/* Thumbnail 16:9 */}
        <div
          style={{
            position: "relative",
            width: "100%",
            aspectRatio: "16 / 9",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ...thumbStyle,
          }}
        >
          {/* Play-knop */}
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: "50%",
              border: "2px solid rgba(248,250,252,0.9)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background:
                "radial-gradient(circle at 30% 30%, rgba(248,250,252,0.16), rgba(15,23,42,0.9))",
            }}
          >
            <div
              style={{
                marginLeft: 3,
                width: 0,
                height: 0,
                borderTop: "7px solid transparent",
                borderBottom: "7px solid transparent",
                borderLeft: "12px solid #f9fafb",
              }}
            />
          </div>

          {/* Lock-overlay als je geen rechten hebt */}
          {locked && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: "rgba(15,23,42,0.65)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 13,
                color: "#e5e7eb",
              }}
            >
              Abonnement nodig
            </div>
          )}
        </div>

        {/* Titel onder thumbnail */}
        <div
          style={{
            padding: "9px 14px 11px",
            background:
              "linear-gradient(180deg, rgba(15,23,42,0.9), rgba(15,23,42,1))",
          }}
        >
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: "#e5e7eb",
            }}
          >
            {item.matchTitle}
          </div>
        </div>
      </div>
    </button>
  );
}
